import { useSearchParams } from "react-router-dom";
import serviceApi from "../../services/api/ServiceCategory";
import { useEffect, useState } from "react";
import { IServiceCategory } from "../../services/api/ServiceCategory/types";

const useSearchPromotionalServices = (search: string) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [promotionalSearchAutocomplete, setPromotionalSearchAutocomplete] =
    useState<IServiceCategory[]>([]);

  const fetchPromotinalSearchForAutocomplete = async () => {
    try {
      const response = await serviceApi.searchServices(search);
      setPromotionalSearchAutocomplete(response);
    } catch (error) {
      console.warn("Error fetching promotional services: ", error);
    }
  };

  useEffect(() => {
    if (search.length > 0) fetchPromotinalSearchForAutocomplete();
  }, [search]);

  return { promotionalSearchAutocomplete };
};

export default useSearchPromotionalServices;
